export const NewAssignmentMutations = {
  SetAssignmentContractorSuccess: 'setAssignmentContractorSuccess',
  SetAssignmentClientSuccess: 'setAssignmentClientSuccess',
  SetAssignmentBranchSuccess: 'setAssignmentBranchSuccess',
  SetNewAssignmentSuccess: 'setNewAssignmentSuccess',
  ResetAssignmentClientSuccess: 'NewAssignmentMutations.ResetAssignmentClientSuccess'
};

export const NewAssignmentActions = {
  SetAssignmentContractor: 'setAssignmentContractor',
  SetAssignmentClient: 'setAssignmentClient',
  SetAssignmentBranch: 'setAssignmentBranch',
  SetNewAssignment: 'setNewAssignment',
  ResetAssignmentClient: 'NewAssignmentActions.ResetAssignmentClient'
};

export const NewAssignmentGetters = {
  NewAssignment: 'NewAssignmentGetters.NewAssignment'
};
